(function () {
  if (window.__RB_V2_LOADED__) return;
  window.__RB_V2_LOADED__ = true;

  // ----------------- CONFIG -----------------
  var RB = {
    storageKey: "RB_SESSION_V2",
    pages: {
      chooseDiamond: "/pages/choose-diamond",
      chooseSetting: "/pages/choose-setting",
      chooseGemstone: "/pages/choose-gemstone",
      complete: "/pages/complete-ring"
    },
    collections: {
      diamond: "build-a-diamond",
      setting: "build-a-ring",
      gemstone: "build-a-gemstone"
    },
    money: { currency: "MYR", locale: "en-MY" },
    pageSize: 24
  };

  // ----------------- UTIL -----------------
  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function getParam(name) {
    try { return new URL(window.location.href).searchParams.get(name); }
    catch (e) { return null; }
  }

  function esc(s) {
    return String(s == null ? "" : s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function fmtMoneyCents(cents) {
    var amt = (Number(cents || 0) / 100);
    try {
      return new Intl.NumberFormat(RB.money.locale, { style: "currency", currency: RB.money.currency }).format(amt);
    } catch (e) {
      return "RM " + amt.toFixed(2);
    }
  }

  function readSession() {
    try { return JSON.parse(localStorage.getItem(RB.storageKey) || "null"); }
    catch (e) { return null; }
  }

  function writeSession(s) {
    localStorage.setItem(RB.storageKey, JSON.stringify(s));
  }

  function clearSession() {
    localStorage.removeItem(RB.storageKey);
  }

  function makePairId() {
    var d = new Date();
    function pad(n) { return String(n).padStart(2, "0"); }
    return [
      "PJ",
      d.getFullYear(),
      pad(d.getMonth() + 1),
      pad(d.getDate()),
      pad(d.getHours()),
      pad(d.getMinutes()),
      pad(d.getSeconds()),
      Math.random().toString(16).slice(2, 6).toUpperCase()
    ].join("-");
  }

  function ensureSession() {
    var s = readSession();
    if (!s) {
      s = {
        pair_id: makePairId(),
        started_at: Date.now(),
        started_with: null,
        start_mode: null,
        diamond: null,   // used for "stone" (diamond or gemstone)
        setting: null,
        stone_mode: "lab" // lab | mined (only affects diamond page filtering)
      };
      writeSession(s);
    } else {
      if (!s.pair_id) s.pair_id = makePairId();
      if (!s.started_at) s.started_at = Date.now();
      if (!("diamond" in s)) s.diamond = null;
      if (!("setting" in s)) s.setting = null;
      if (!("stone_mode" in s) || !s.stone_mode) s.stone_mode = "lab";

      if (!s.started_with && (s.start_mode === "diamond" || s.start_mode === "setting")) {
        s.started_with = s.start_mode;
      }
      if (!s.start_mode && (s.started_with === "diamond" || s.started_with === "setting")) {
        s.start_mode = s.started_with;
      }

      writeSession(s);
    }
    return s;
  }

  function setStartedWith(session, mode) {
    if (mode !== "diamond" && mode !== "setting") return;
    session.started_with = mode;
    session.start_mode = mode;
    writeSession(session);
  }

  function safeNum(n) {
    var x = Number(n);
    return isFinite(x) ? x : null;
  }

  // Try to read currently selected variant id from the product form (Metal now, Size later)
  function getSelectedVariantIdFromButton(startBtn) {
    var formId = startBtn.getAttribute("data-rb-product-form-id");
    var formEl = formId ? document.getElementById(formId) : null;

    if (!formEl) {
      var pf = startBtn.closest("product-form");
      if (pf) formEl = qs("form", pf);
    }
    if (!formEl) {
      formEl = startBtn.closest("form");
    }

    var idInput = formEl ? qs('input[name="id"]', formEl) : null;
    var vid = idInput ? idInput.value : null;

    // fallback (older markup)
    if (!vid) vid = startBtn.getAttribute("data-rb-variant-id");

    return vid ? String(vid) : null;
  }

  async function fetchProductByHandle(handle) {
    var url = "/products/" + encodeURIComponent(handle) + ".js";
    var res = await fetch(url, { credentials: "same-origin" });
    if (!res.ok) throw new Error("Failed to load product: " + handle);
    return await res.json();
  }

  function priceCentsFromProductJsVariant(v) {
    var p = (v && v.price != null) ? v.price : 0;
    return Number(p) || 0;
  }

  function imgForProductJs(p) {
    if (p && p.featured_image) return p.featured_image;
    if (p && p.images && p.images[0]) return p.images[0];
    return "";
  }

  function findVariantById(productJs, variantId) {
    if (!productJs || !productJs.variants || !variantId) return null;
    var vid = Number(variantId);
    return (productJs.variants || []).find(function (v) { return Number(v.id) === vid; }) || null;
  }

  // ----------------- DUPLICATE SUMMARY BLOCK (safety) -----------------
  // If theme still contains [data-rb-summary], we hard-clear it so it does not render elsewhere.
  function clearInlineSummaryIfExists() {
    var el = qs("[data-rb-summary]");
    if (el) el.innerHTML = "";
  }

  // ----------------- GLOBAL START BUTTON (PRODUCT PAGE) -----------------
  document.addEventListener("click", async function (e) {
    var startBtn = e.target.closest("[data-rb-start-product]");
    if (!startBtn) return;

    e.preventDefault();

    // Step B patch: allow "gemstone" here too
    var kind = startBtn.getAttribute("data-rb-kind"); // "diamond" or "setting" or "gemstone"
    var handle = startBtn.getAttribute("data-rb-handle") || null;
    var title = startBtn.getAttribute("data-rb-title") || null;
    var url = startBtn.getAttribute("data-rb-url") || null;

    // IMPORTANT: read selected variant from the product form
    var variantId = getSelectedVariantIdFromButton(startBtn);

    var s = ensureSession();

    // Preserve original start if already set, otherwise set it now
    if (!s.started_with && !s.start_mode) {
      // gemstone is a "stone", so started_with should be "diamond" not "setting"
      setStartedWith(s, (kind === "setting") ? "setting" : "diamond");
      s = ensureSession();
    }

    var startKey = encodeURIComponent(s.started_with || s.start_mode || "diamond");

    // Enrich with real price + image using product.js so step bar can show correct price
    var enriched = null;
    if (handle && variantId) {
      try {
        var pjs = await fetchProductByHandle(handle);
        var v = findVariantById(pjs, variantId) || (pjs.variants && pjs.variants[0]) || null;
        enriched = {
          price_cents: v ? priceCentsFromProductJsVariant(v) : null,
          image: imgForProductJs(pjs),
          title: title || (pjs && pjs.title ? pjs.title : null)
        };
      } catch (err) {
        enriched = null;
      }
    }

    // Step B patch: gemstone behaves exactly like diamond here
    if (kind === "diamond" || kind === "gemstone") {
      s.diamond = {
        handle: handle,
        title: (enriched && enriched.title) ? enriched.title : title,
        image: (enriched && enriched.image) ? enriched.image : null,
        product_url: url,
        variant_id: variantId ? Number(variantId) : null,
        price_cents: (enriched && typeof enriched.price_cents === "number") ? enriched.price_cents : null,
        stone_kind: (kind === "gemstone") ? "gemstone" : "diamond"
      };
      writeSession(s);

      if (s.setting && s.setting.handle) {
        window.location.href = RB.pages.complete + "?start=" + startKey;
        return;
      }

      window.location.href = RB.pages.chooseSetting + "?start=" + startKey;
      return;
    }

    if (kind === "setting") {
      s.setting = {
        handle: handle,
        title: (enriched && enriched.title) ? enriched.title : title,
        image: (enriched && enriched.image) ? enriched.image : null,
        product_url: url,
        variant_id: variantId ? Number(variantId) : null,
        price_cents: (enriched && typeof enriched.price_cents === "number") ? enriched.price_cents : null
      };
      writeSession(s);

      if (s.diamond && s.diamond.handle) {
        window.location.href = RB.pages.complete + "?start=" + startKey;
        return;
      }

      window.location.href = RB.pages.chooseDiamond + "?start=" + startKey;
      return;
    }
  });

  // ----------------- CART -----------------
  var inFlight = false;

  async function addLineItems(items) {
    var res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: items })
    });

    if (!res.ok) {
      var txt = await res.text();
      throw new Error("Cart add failed: " + txt);
    }
    return res.json();
  }

  async function finalizeToCart(session, chosenStoneVariantId, chosenSettingVariantId, chosenSettingHandle) {
    if (inFlight) return;
    inFlight = true;

    var pairId = session.pair_id || makePairId();

    var stoneProps = {
      "Builder Pair ID": pairId,
      "Paired with": chosenSettingHandle || "Ring Setting"
    };

    var settingProps = {
      "Builder Pair ID": pairId,
      "Paired with": "Stone"
    };

    try {
      await addLineItems([
        { id: Number(chosenStoneVariantId), quantity: 1, properties: stoneProps },
        { id: Number(chosenSettingVariantId), quantity: 1, properties: settingProps }
      ]);
      clearSession();
      window.location.href = "/cart";
    } catch (err) {
      console.error(err);
      alert("Could not add items to cart. Please try again.");
    } finally {
      inFlight = false;
    }
  }

  // ----------------- DATA FETCH -----------------
  async function fetchCollectionProducts(handle, page, limit) {
    var url = "/collections/" + encodeURIComponent(handle) + "/products.json?page=" + (page || 1) + "&limit=" + (limit || RB.pageSize);
    var res = await fetch(url, { credentials: "same-origin" });
    if (!res.ok) throw new Error("Failed to load collection: " + handle);
    var json = await res.json();
    return (json && json.products) ? json.products : [];
  }

  // ----------------- PRICE HELPERS -----------------
  // products.json: variant.price is string like "3500.00"
  function priceCentsFromProductsJsonVariant(v) {
    var p = (v && v.price != null) ? String(v.price) : "0";
    var num = parseFloat(p || "0");
    if (!isFinite(num)) num = 0;
    return Math.round(num * 100);
  }

  function getFirstVariantMetaFromProductsJson(p) {
    var v = (p.variants && p.variants[0]) ? p.variants[0] : null;
    return {
      variant_id: v ? v.id : null,
      price_cents: v ? priceCentsFromProductsJsonVariant(v) : 0
    };
  }

  // ----------------- STEP BAR -----------------
  function rbOrder(session) {
    var started = (session && (session.started_with || session.start_mode)) || "diamond";
    if (started === "setting") return ["choose-setting", "choose-diamond", "complete"];
    return ["choose-diamond", "choose-setting", "complete"];
  }

  function rbLabels() {
    return {
      "choose-diamond": { title: "Choose a", label: "Stone", icon: "diamond" },
      "choose-setting": { title: "Choose a", label: "Setting", icon: "ring" },
      "complete": { title: "Complete", label: "Ring", icon: "check" }
    };
  }

  // Return { title, price_cents } for a given step key
  function rbChosenMeta(key, session) {
    if (!session) return null;

    if (key === "choose-diamond" && session.diamond && session.diamond.title) {
      return {
        title: session.diamond.title,
        price_cents: (typeof session.diamond.price_cents === "number") ? session.diamond.price_cents : null
      };
    }

    if (key === "choose-setting" && session.setting && session.setting.title) {
      return {
        title: session.setting.title,
        price_cents: (typeof session.setting.price_cents === "number") ? session.setting.price_cents : null
      };
    }

    return null;
  }

  function renderSteps(stepsRoot, session, pageKey) {
    if (!stepsRoot) return;

    var order = rbOrder(session);
    var labels = rbLabels();
    var activeIdx = order.indexOf(pageKey);

    var iconMap = {
      diamond: '<svg class="rb-ico" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M3 9l4-5h10l4 5-9 11L3 9Z" stroke="currentColor" stroke-width="1.2"/><path d="M7 4l5 16M17 4l-5 16M3 9h18" stroke="currentColor" stroke-width="1.2"/></svg>',
      ring: '<svg class="rb-ico" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 3l3 4-3 4-3-4 3-4Z" stroke="currentColor" stroke-width="1.2"/><path d="M6.5 12.5c1.8-1.8 4-2.7 5.5-2.7s3.7.9 5.5 2.7c1.7 1.7 2.5 3.8 2.5 5 0 2.2-3.6 3.5-8 3.5s-8-1.3-8-3.5c0-1.2.8-3.3 2.5-5Z" stroke="currentColor" stroke-width="1.2"/></svg>',
      check: '<svg class="rb-ico" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M20 6L9 17l-5-5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>'
    };

    stepsRoot.innerHTML = order.map(function (key, idx) {
      var meta = labels[key];
      var isDone = idx < activeIdx;
      var isActive = idx === activeIdx;
      var chosen = rbChosenMeta(key, session);

      var cls = "rb__step";
      if (isActive) cls += " is-active";
      if (isDone) cls += " is-done";

      var chosenHtml = "";
      if (chosen && chosen.title) {
        chosenHtml =
          '<div class="rb__step-choice" style="margin-top:4px; font-size:12px; opacity:.75; line-height:1.25;">' +
            '<div>' + esc(chosen.title) + "</div>" +
            (typeof chosen.price_cents === "number"
              ? '<div style="margin-top:2px;">' + esc(fmtMoneyCents(chosen.price_cents)) + "</div>"
              : "") +
          "</div>";
      }

      return (
        '<div class="' + cls + '">' +
          '<div class="rb__step-num">' + (idx + 1) + "</div>" +
          '<div class="rb__step-icon">' + (iconMap[meta.icon] || "") + "</div>" +
          "<div>" +
            '<div class="rb__step-title">' + esc(meta.title) + "</div>" +
            '<div class="rb__step-label">' + esc(meta.label) + "</div>" +
            chosenHtml +
          "</div>" +
        "</div>"
      );
    }).join("");
  }

  // ----------------- FILTER MODEL (MVP) -----------------
  function buildDefaultFilters(kind) {
    if (kind === "diamond") {
      // Lab vs mined is controlled by tabs (stone_mode) now, not by chips
      return [
        { key: "shape", label: "Shape", type: "chips", values: ["Round", "Oval", "Emerald", "Cushion", "Princess", "Pear", "Marquise", "Heart"] },
        { key: "price", label: "Price (RM)", type: "range" }
      ];
    }

    if (kind === "gemstone") {
      return [
        { key: "type", label: "Gemstone", type: "chips", values: ["Sapphire", "Ruby", "Emerald", "Moissanite", "Spinel"] },
        { key: "color", label: "Color", type: "chips", values: ["Blue", "Pink", "Green", "Yellow", "White", "Red", "Purple"] },
        { key: "price", label: "Price (RM)", type: "range" }
      ];
    }

    // setting
    return [
      { key: "style", label: "Style", type: "chips", values: ["Solitaire", "Halo", "Pavé", "2-Stone", "3-Stone", "Twist", "Channel Set"] },
      { key: "metal", label: "Metal", type: "chips", values: ["14K Yellow Gold", "18K Yellow Gold", "14K White Gold", "18K White Gold", "14K Rose Gold", "18K Rose Gold", "Platinum"] },
      { key: "price", label: "Price (RM)", type: "range" }
    ];
  }

  function productHasAnyTag(p, tags) {
    if (!tags || !tags.length) return true;
    var ptags = (p.tags || []);
    for (var i = 0; i < tags.length; i++) {
      if (ptags.indexOf(tags[i]) !== -1) return true;
    }
    return false;
  }

  // Apply lab/mined gating for diamond page via tags
  function productMatchesStoneMode(p, stoneMode) {
    // Tag your products:
    // Lab diamonds: "Lab" or "Lab Grown" or "Lab-Grown"
    // Mined diamonds: "Natural" or "Mined" or "Mined Diamond"
    var tags = p.tags || [];

    if (stoneMode === "lab") {
      return tags.indexOf("Lab") !== -1 || tags.indexOf("Lab Grown") !== -1 || tags.indexOf("Lab-Grown") !== -1;
    }
    if (stoneMode === "mined") {
      return tags.indexOf("Natural") !== -1 || tags.indexOf("Mined") !== -1 || tags.indexOf("Mined Diamond") !== -1;
    }
    return true;
  }

  function applyFilters(products, state, kind) {
    var out = products.slice();

    // Chips filters are tag based
    Object.keys(state.chips).forEach(function (k) {
      var set = state.chips[k];
      if (!set || set.size === 0) return;

      var wanted = Array.from(set);
      out = out.filter(function (p) {
        return productHasAnyTag(p, wanted);
      });
    });

    // Diamond tab gating (lab vs mined)
    if (kind === "diamond") {
      out = out.filter(function (p) {
        return productMatchesStoneMode(p, state.stoneMode || "lab");
      });
    }

    // Price range
    if (state.priceMinCents != null || state.priceMaxCents != null) {
      out = out.filter(function (p) {
        var meta = getFirstVariantMetaFromProductsJson(p);
        var cents = meta.price_cents;
        if (state.priceMinCents != null && cents < state.priceMinCents) return false;
        if (state.priceMaxCents != null && cents > state.priceMaxCents) return false;
        return true;
      });
    }

    return out;
  }

  // ----------------- CHOOSE PAGE -----------------
  async function initChoosePage(rbRoot) {
    clearInlineSummaryIfExists();

    var kind = rbRoot.getAttribute("data-rb-kind"); // diamond | setting | gemstone
    var collection = rbRoot.getAttribute("data-rb-collection");

    var start = getParam("start"); // "diamond" or "setting"
    var session = ensureSession();

    if (start === "diamond" || start === "setting") {
      setStartedWith(session, start);
      session = ensureSession();
    } else if (!session.started_with && !session.start_mode) {
      setStartedWith(session, "diamond");
      session = ensureSession();
    }

    // Step key mapping:
    // setting page: choose-setting
    // diamond or gemstone page: choose-diamond (stone step)
    var pageKey = (kind === "setting") ? "choose-setting" : "choose-diamond";

    var stepsRoot = qs("[data-rb-steps]", rbRoot);
    renderSteps(stepsRoot, session, pageKey);

    var filtersRoot = qs("[data-rb-filters]", rbRoot);
    var gridRoot = qs("[data-rb-grid]", rbRoot);
    var countRoot = qs("[data-rb-count]", rbRoot);
    var clearBtn = qs("[data-rb-clear]", rbRoot);
    var loadMoreBtn = qs("[data-rb-loadmore]", rbRoot);

    // Tabs (only relevant on diamond page)
    var stoneTabs = qs("[data-rb-stone-tabs]", rbRoot);

    var state = {
      chips: {},
      priceMinCents: null,
      priceMaxCents: null,
      page: 1,
      loaded: [],
      filtered: [],
      stoneMode: (session && session.stone_mode) ? session.stone_mode : "lab"
    };

    function ensureChipSet(key) {
      if (!state.chips[key]) state.chips[key] = new Set();
      return state.chips[key];
    }

    function setStoneMode(mode) {
      state.stoneMode = mode;
      var s = ensureSession();
      s.stone_mode = mode;
      writeSession(s);
    }

    // IMPORTANT:
    // Your Liquid might use data-stone OR data-stone-type.
    // This supports both so you never get stuck again.
    function readStoneModeFromBtn(btn) {
      return btn.getAttribute("data-stone") || btn.getAttribute("data-stone-type");
    }

    function syncTabActiveUI() {
      if (!stoneTabs) return;
      var buttons = qsa("[data-stone],[data-stone-type]", stoneTabs);
      buttons.forEach(function (b) {
        var mode = readStoneModeFromBtn(b);
        var active = (mode === (state.stoneMode || "lab"));
        if (mode === "gemstone") active = false;
        b.classList.toggle("is-active", active);
      });
    }

    function renderFilters() {
      var defs = buildDefaultFilters(kind);
      if (!filtersRoot) return;

      filtersRoot.innerHTML = defs.map(function (f) {
        if (f.type === "chips") {
          return (
            '<div class="rb__filter" data-rb-filter="' + esc(f.key) + '">' +
              "<h3>" + esc(f.label) + "</h3>" +
              '<div class="rb__chips">' +
                f.values.map(function (v) {
                  return '<button type="button" class="rb__chip" data-rb-chip data-key="' + esc(f.key) + '" data-val="' + esc(v) + '">' + esc(v) + "</button>";
                }).join("") +
              "</div>" +
            "</div>"
          );
        }

        return (
          '<div class="rb__filter" data-rb-filter="price">' +
            "<h3>" + esc(f.label) + "</h3>" +
            '<div class="rb__range">' +
              '<input type="number" inputmode="numeric" placeholder="Min" data-rb-pricemin />' +
              '<input type="number" inputmode="numeric" placeholder="Max" data-rb-pricemax />' +
            "</div>" +
          "</div>"
        );
      }).join("");
    }

    function renderGrid(list) {
      if (!gridRoot) return;

      var btnLabel;
      if (kind === "setting") btnLabel = "Select this setting";
      else if (kind === "gemstone") btnLabel = "Select this gemstone";
      else btnLabel = "Select this diamond";

      gridRoot.innerHTML = list.map(function (p) {
        var img = (p.images && p.images[0] && p.images[0].src) ? p.images[0].src : "";
        var meta = getFirstVariantMetaFromProductsJson(p);
        var cents = meta.price_cents;
        var productUrl = "/products/" + p.handle;

        return (
          '<div class="rb__card">' +
            '<a class="rb__card-link" href="' + esc(productUrl) + '" aria-label="' + esc(p.title) + '" style="text-decoration:none; color:inherit;">' +
              '<div class="rb__card-media">' +
                (img ? '<img src="' + esc(img) + '" alt=""/>' : "") +
              "</div>" +
              '<div class="rb__card-body" style="gap:8px;">' +
                '<div class="rb__card-title">' + esc(p.title) + "</div>" +
                '<div class="rb__card-price">' + esc(fmtMoneyCents(cents)) + "</div>" +
              "</div>" +
            "</a>" +
            '<div class="rb__card-body" style="padding-top:0;">' +
              '<button type="button" class="rb__btn rb__btn--ghost" ' +
                'data-rb-select ' +
                'data-handle="' + esc(p.handle) + '" ' +
                'data-title="' + esc(p.title) + '" ' +
                'data-img="' + esc(img) + '" ' +
                'data-url="' + esc(productUrl) + '" ' +
                'data-variant-id="' + esc(meta.variant_id) + '" ' +
                'data-price-cents="' + esc(cents) + '"' +
              ">" + esc(btnLabel) + "</button>" +
            "</div>" +
          "</div>"
        );
      }).join("");
    }

    function refresh() {
      var filtered = applyFilters(state.loaded, state, kind);
      state.filtered = filtered;

      if (countRoot) countRoot.textContent = "Showing " + filtered.length + " of " + state.loaded.length;
      renderGrid(filtered);

      if (filtersRoot) {
        qsa("[data-rb-chip]", filtersRoot).forEach(function (b) {
          var k = b.getAttribute("data-key");
          var v = b.getAttribute("data-val");
          var set = ensureChipSet(k);
          if (set.has(v)) b.classList.add("is-on");
          else b.classList.remove("is-on");
        });
      }
    }

    async function loadPage() {
      var products = await fetchCollectionProducts(collection, state.page, RB.pageSize);
      state.loaded = state.loaded.concat(products);

      if (loadMoreBtn) loadMoreBtn.hidden = !(products.length >= RB.pageSize);
      refresh();
    }

    // Tabs handler (diamond page only)
    if (stoneTabs && kind === "diamond") {
      syncTabActiveUI();
      stoneTabs.addEventListener("click", function (e) {
        var btn = e.target.closest("[data-stone],[data-stone-type]");
        if (!btn) return;

        var mode = readStoneModeFromBtn(btn);

        var s = ensureSession();
        var startKey = encodeURIComponent(s.started_with || s.start_mode || "diamond");

        if (mode === "gemstone") {
          // Optional override from Liquid
          var link = btn.getAttribute("data-gemstone-link") || RB.pages.chooseGemstone;
          window.location.href = link + "?start=" + startKey;
          return;
        }

        setStoneMode(mode);
        syncTabActiveUI();
        refresh();
      });
    }

    if (filtersRoot) {
      filtersRoot.addEventListener("click", function (e) {
        var btn = e.target.closest("[data-rb-chip]");
        if (!btn) return;

        var k = btn.getAttribute("data-key");
        var v = btn.getAttribute("data-val");
        var set = ensureChipSet(k);

        if (set.has(v)) set.delete(v);
        else set.add(v);

        refresh();
      });

      filtersRoot.addEventListener("input", function (e) {
        if (e.target && e.target.matches("[data-rb-pricemin]")) {
          var val = e.target.value ? Number(e.target.value) : null;
          state.priceMinCents = (val == null || !isFinite(val)) ? null : Math.round(val * 100);
          refresh();
        }
        if (e.target && e.target.matches("[data-rb-pricemax]")) {
          var val2 = e.target.value ? Number(e.target.value) : null;
          state.priceMaxCents = (val2 == null || !isFinite(val2)) ? null : Math.round(val2 * 100);
          refresh();
        }
      });
    }

    if (clearBtn) {
      clearBtn.addEventListener("click", function () {
        Object.keys(state.chips).forEach(function (k) { state.chips[k].clear(); });
        state.priceMinCents = null;
        state.priceMaxCents = null;

        if (filtersRoot) {
          var minInput = qs("[data-rb-pricemin]", filtersRoot);
          var maxInput = qs("[data-rb-pricemax]", filtersRoot);
          if (minInput) minInput.value = "";
          if (maxInput) maxInput.value = "";
        }

        refresh();
      });
    }

    if (loadMoreBtn) {
      loadMoreBtn.addEventListener("click", async function () {
        state.page += 1;
        await loadPage();
      });
    }

    if (gridRoot) {
      gridRoot.addEventListener("click", function (e) {
        var btn = e.target.closest("[data-rb-select]");
        if (!btn) return;

        var handle = btn.getAttribute("data-handle");
        var title = btn.getAttribute("data-title");
        var img = btn.getAttribute("data-img");
        var url = btn.getAttribute("data-url");
        var variantId = btn.getAttribute("data-variant-id");
        var priceCents = btn.getAttribute("data-price-cents");

        var s = ensureSession();

        if (!s.started_with && !s.start_mode) setStartedWith(s, "diamond");
        s = ensureSession();

        var startKey = encodeURIComponent(s.started_with || s.start_mode || "diamond");

        var payload = {
          handle: handle,
          title: title || null,
          image: img || null,
          product_url: url || ("/products/" + handle),
          variant_id: variantId ? Number(variantId) : null,
          price_cents: safeNum(priceCents),
          stone_kind: (kind === "gemstone") ? "gemstone" : (kind === "diamond" ? "diamond" : null)
        };

        // Stone selection (diamond or gemstone) always saves into s.diamond
        if (kind === "diamond" || kind === "gemstone") {
          s.diamond = payload;
          writeSession(s);

          if (s.setting && s.setting.handle) {
            window.location.href = RB.pages.complete + "?start=" + startKey;
            return;
          }

          window.location.href = RB.pages.chooseSetting + "?start=" + startKey;
          return;
        }

        // Setting selection
        s.setting = payload;
        writeSession(s);

        if (s.diamond && s.diamond.handle) {
          window.location.href = RB.pages.complete + "?start=" + startKey;
          return;
        }

        window.location.href = RB.pages.chooseDiamond + "?start=" + startKey;
      });
    }

    renderFilters();
    await loadPage();

    // Re-render steps after load so step bar reflects latest session values
    var s2 = ensureSession();
    renderSteps(stepsRoot, s2, pageKey);
  }

  // ----------------- COMPLETE PAGE -----------------
  async function initCompletePage(rbRoot) {
    clearInlineSummaryIfExists();

    var session = ensureSession();

    var start = getParam("start");
    if (start === "diamond" || start === "setting") {
      setStartedWith(session, start);
      session = ensureSession();
    }
    if (!session.started_with && !session.start_mode) setStartedWith(session, "diamond");
    session = ensureSession();

    var stepsRoot = qs("[data-rb-steps]", rbRoot);
    renderSteps(stepsRoot, session, "complete");

    var left = qs("[data-rb-complete-left]", rbRoot);
    var right = qs("[data-rb-complete-right]", rbRoot);

    if (!session.diamond || !session.diamond.handle || !session.setting || !session.setting.handle) {
      var builderHref = (session.started_with === "setting")
        ? (RB.pages.chooseSetting + "?start=setting")
        : (RB.pages.chooseDiamond + "?start=diamond");

      if (left) left.innerHTML = '<p class="rb__danger">Missing stone or setting. Please choose both first.</p>';
      if (right) right.innerHTML = '<a class="rb__btn rb__btn--ghost" href="' + esc(builderHref) + '">Go to builder</a>';
      return;
    }

    var stone = null;
    var setting = null;

    try {
      stone = await fetchProductByHandle(session.diamond.handle);
      setting = await fetchProductByHandle(session.setting.handle);
    } catch (e) {
      console.error(e);
    }

    if (!stone || !setting) {
      if (left) left.innerHTML = '<p class="rb__danger">Could not load product data. Please refresh and try again.</p>';
      return;
    }

    // Stone variant: if we stored a variant id, use it
    var stoneVariant = null;
    if (session.diamond && session.diamond.variant_id) {
      stoneVariant = findVariantById(stone, session.diamond.variant_id) || null;
    }
    if (!stoneVariant) stoneVariant = (stone.variants && stone.variants[0]) ? stone.variants[0] : null;

    // Setting variant: if we stored a variant id, use it
    var settingVariant = null;
    if (session.setting && session.setting.variant_id) {
      settingVariant = findVariantById(setting, session.setting.variant_id) || null;
    }
    if (!settingVariant) settingVariant = (setting.variants && setting.variants[0]) ? setting.variants[0] : null;

    function renderSummaryCard(title, img, priceCents, label, linkUrl) {
      return (
        '<div class="rb__summary">' +
          (img ? '<a href="' + esc(linkUrl) + '"><img src="' + esc(img) + '" alt=""/></a>' : "") +
          "<div>" +
            '<p style="margin:0; font-size:12px; opacity:.7; text-transform:uppercase; letter-spacing:.06em;">' + esc(label) + "</p>" +
            '<h2 style="margin-top:6px;">' + esc(title) + "</h2>" +
            "<p>" + esc(fmtMoneyCents(priceCents)) + "</p>" +
          "</div>" +
        "</div>"
      );
    }

    var stoneTitle = (session.diamond && session.diamond.title) ? session.diamond.title : stone.title;
    var settingTitle = (session.setting && session.setting.title) ? session.setting.title : setting.title;

    var stoneImg = (session.diamond && session.diamond.image) ? session.diamond.image : imgForProductJs(stone);
    var settingImg = (session.setting && session.setting.image) ? session.setting.image : imgForProductJs(setting);

    var stonePrice = (session.diamond && typeof session.diamond.price_cents === "number")
      ? session.diamond.price_cents
      : priceCentsFromProductJsVariant(stoneVariant);

    var settingPrice = (session.setting && typeof session.setting.price_cents === "number")
      ? session.setting.price_cents
      : priceCentsFromProductJsVariant(settingVariant);

    var changeHref = (session.started_with === "setting")
      ? (RB.pages.chooseSetting + "?start=setting")
      : (RB.pages.chooseDiamond + "?start=diamond");

    if (left) {
      left.innerHTML =
        renderSummaryCard(stoneTitle, stoneImg, stonePrice, "Selected Stone", "/products/" + session.diamond.handle) +
        renderSummaryCard(settingTitle, settingImg, settingPrice, "Selected Setting", "/products/" + session.setting.handle) +
        '<a class="rb__btn rb__btn--ghost" href="' + esc(changeHref) + '">Change selections</a>';
    }

    // Build option selects from variants so it supports Metal now and Size later
    function getOptionCountFromVariants(p) {
      if (!p || !p.variants || !p.variants[0]) return 0;
      var v = p.variants[0];
      var c = 0;
      if (v.option1) c += 1;
      if (v.option2) c += 1;
      if (v.option3) c += 1;
      return c;
    }

    function getOptionName(p, idx) {
      if (!p || !p.options || !p.options[idx]) return "Option " + (idx + 1);
      var o = p.options[idx];
      if (typeof o === "string") return o;
      if (o && o.name) return o.name;
      return "Option " + (idx + 1);
    }

    function getOptionValuesFromVariants(p, idx) {
      var key = "option" + (idx + 1);
      var set = {};
      (p.variants || []).forEach(function (v) {
        var val = v[key];
        if (val) set[val] = true;
      });
      return Object.keys(set);
    }

    var optionCount = Array.isArray(setting.options) ? setting.options.length : getOptionCountFromVariants(setting);
    var preset = settingVariant || null;

    var optionHtml = "";
    for (var i = 0; i < optionCount; i++) {
      var name = getOptionName(setting, i);
      var values = getOptionValuesFromVariants(setting, i);
      var presetVal = preset ? preset["option" + (i + 1)] : null;

      optionHtml +=
        '<div class="rb__formrow">' +
          "<label>" + esc(name) + "</label>" +
          '<select data-rb-setting-opt data-index="' + i + '">' +
            values.map(function (val) {
              var selected = (presetVal && val === presetVal) ? ' selected="selected"' : "";
              return '<option value="' + esc(val) + '"' + selected + ">" + esc(val) + "</option>";
            }).join("") +
          "</select>" +
        "</div>";
    }

    if (right) {
      right.innerHTML =
        '<h2 style="margin:0 0 8px;">Complete Ring</h2>' +
        '<p style="margin:0 0 10px; opacity:.75;">Confirm your setting options, then add the completed ring to cart.</p>' +
        optionHtml +
        '<div class="rb__total"><span>Total</span><span data-rb-total></span></div>' +
        '<div style="margin-top:14px;"><button type="button" class="rb__btn" data-rb-add>Add completed ring to cart</button></div>';
    }

    function findSettingVariantByOptions() {
      if (!right) return settingVariant;
      var selects = qsa("[data-rb-setting-opt]", right);
      var chosen = selects.map(function (s) { return s.value; });

      var match = (setting.variants || []).find(function (v) {
        for (var i2 = 0; i2 < chosen.length; i2++) {
          var key2 = "option" + (i2 + 1);
          if ((v[key2] || "") !== chosen[i2]) return false;
        }
        return true;
      });

      return match || (setting.variants && setting.variants[0]) || null;
    }

    function refreshTotal() {
      settingVariant = findSettingVariantByOptions();

      var stoneCents = priceCentsFromProductJsVariant(stoneVariant);
      var settingCents = priceCentsFromProductJsVariant(settingVariant);

      var total = stoneCents + settingCents;
      var totalEl = right ? qs("[data-rb-total]", right) : null;
      if (totalEl) totalEl.textContent = fmtMoneyCents(total);
    }

    if (right) {
      right.addEventListener("change", function (e) {
        if (e.target && e.target.matches("[data-rb-setting-opt]")) refreshTotal();
      });
    }

    refreshTotal();

    if (right) {
      var addBtn = qs("[data-rb-add]", right);
      if (addBtn) {
        addBtn.addEventListener("click", async function () {
          settingVariant = findSettingVariantByOptions();
          if (!stoneVariant || !settingVariant) {
            alert("Could not detect stone or setting variant.");
            return;
          }

          // Persist chosen setting variant back to session (so step bar stays consistent)
          var s2 = ensureSession();
          if (s2.setting) {
            s2.setting.variant_id = Number(settingVariant.id);
            s2.setting.price_cents = priceCentsFromProductJsVariant(settingVariant);
            writeSession(s2);
          }

          await finalizeToCart(session, stoneVariant.id, settingVariant.id, setting.handle);
        });
      }
    }

    // Re-render steps at the end so step bar reflects latest prices
    var s3 = ensureSession();
    renderSteps(stepsRoot, s3, "complete");
  }

  // ----------------- BOOT (BUILDER PAGES ONLY) -----------------
  document.addEventListener("DOMContentLoaded", function () {
    var rbRoot = qs(".rb");
    if (!rbRoot) return;

    clearInlineSummaryIfExists();

    var s = ensureSession();

    var start = getParam("start");
    if (start === "diamond" || start === "setting") {
      setStartedWith(s, start);
      s = ensureSession();
    }

    var page = rbRoot.getAttribute("data-rb-page"); // "choose" or "complete"
    if (page === "choose") initChoosePage(rbRoot);
    if (page === "complete") initCompletePage(rbRoot);
  });
})();
